import { type ProgressFactory, Progress as MantineProgress } from "@mantine/core";
import { componentWrapper } from "../../utilities";
import type { IProps } from "./progress.types";

/**
 * Progress bar component for displaying percentage values visually.
 * @param props - Mantine Progress props.
 * @returns The Progress component.
 */
const Progress = componentWrapper<ProgressFactory, IProps>("Progress", (props, ref) => {
    return <MantineProgress ref={ref} {...props} />;
});

export { Progress };
